export enum AgcProfile {
  FAKE_DATA = 'FAKE_DATA',
  WEB = 'WEB',
  IMPORT_STUDENT = 'IMPORT_STUDENT',
  LVR_BILLING = 'LVR_BILLING',
  LVR_STATS = 'LVR_STATS',
  BEXIO = 'BEXIO',
  EXPORT_PRESENCE_ENTRIES = 'EXPORT_PRESENCE_ENTRIES'
}
